import sanitizeHTML from 'sanitize-html';

export const sanitize = (str: string): string => sanitizeHTML(str, { allowedTags: [] });
